import { connect } from "react-redux";
import { courierActions } from "../../actions/courier";
import { locationActions } from "../../actions/location";
import {
  selectCourierLoadingFromState,
  selectCourierApiErrorFromState,
  selectCourierZonesFromState,
  selectCourierCentersFromState,
  selectCouriersFromState,
  selectCourierRoundsFromState,
  selectCourierRoundStopsFromState,
  selectCourierRoundSchedulesFromState,
  selectCourierShiftsFromState,
  selectCourierTripsFromState,
  selectCourierTripTasksFromState,
  selectEligibleCouriersFromState,
  selectCourierCustodyItemsFromState,
  selectCourierReportsListFromState,
  selectCourierReportFromState,
  selectCourierLiveMonitorFromState
} from "../../selectors/courier";
import { selectCitiesListFromState } from "../../selectors/location";

let Components = {
  CouriersList: require("./couriers-list").default,
  ZonesList: require("./zones-list").default,
  CentersList: require("./centers-list").default,
  RoundsList: require("./rounds-list").default,
  RoundSchedulesList: require("./round-schedules-list").default,
  ShiftsList: require("./shifts-list").default,
  TripsList: require("./trips-list").default,
  OperatorWorkflow: require("./operator-workflow").default,
  ReportsList: require("./reports-list").default,
  LiveMonitor: require("./live-monitor").default
};

const mapDispatchToProps = {
  // couriers
  getCouriers: courierActions.getCouriersRequest,
  createCourier: courierActions.createCourierRequest,
  updateCourier: courierActions.updateCourierRequest,
  // zones
  getCourierZones: courierActions.getCourierZonesRequest,
  createCourierZone: courierActions.createCourierZoneRequest,
  updateCourierZone: courierActions.updateCourierZoneRequest,
  deleteCourierZone: courierActions.deleteCourierZoneRequest,
  reorderCourierZones: courierActions.reorderCourierZonesRequest,
  // centers
  getCourierCenters: courierActions.getCourierCentersRequest,
  createCourierCenter: courierActions.createCourierCenterRequest,
  updateCourierCenter: courierActions.updateCourierCenterRequest,
  deleteCourierCenter: courierActions.deleteCourierCenterRequest,
  reorderCourierZoneCenters: courierActions.reorderCourierZoneCentersRequest,
  // rounds
  getCourierRounds: courierActions.getCourierRoundsRequest,
  createCourierRound: courierActions.createCourierRoundRequest,
  updateCourierRound: courierActions.updateCourierRoundRequest,
  deleteCourierRound: courierActions.deleteCourierRoundRequest,
  // round stops
  getCourierRoundStops: courierActions.getCourierRoundStopsRequest,
  createCourierRoundStop: courierActions.createCourierRoundStopRequest,
  deleteCourierRoundStop: courierActions.deleteCourierRoundStopRequest,
  reorderCourierRoundStops: courierActions.reorderCourierRoundStopsRequest,
  // round schedules
  getCourierRoundSchedules: courierActions.getCourierRoundSchedulesRequest,
  createCourierRoundSchedule: courierActions.createCourierRoundScheduleRequest,
  deleteCourierRoundSchedule: courierActions.deleteCourierRoundScheduleRequest,
  // shifts
  getCourierShifts: courierActions.getCourierShiftsRequest,
  createCourierShift: courierActions.createCourierShiftRequest,
  deleteCourierShift: courierActions.deleteCourierShiftRequest,
  // trips
  getCourierTrips: courierActions.getCourierTripsRequest,
  getCourierTripTasks: courierActions.getCourierTripTasksRequest,
  generateCourierTrips: courierActions.generateCourierTripsRequest,
  getEligibleCouriers: courierActions.getEligibleCouriersRequest,
  assignCourierTrip: courierActions.assignCourierTripRequest,
  cancelCourierTrip: courierActions.cancelCourierTripRequest,
  // operator workflow
  startCourierTrip: courierActions.startCourierTripRequest,
  deliverCourierTrip: courierActions.deliverCourierTripRequest,
  reachCourierTask: courierActions.reachCourierTaskRequest,
  dispatchCourierTask: courierActions.dispatchCourierTaskRequest,
  outcomeCourierTask: courierActions.outcomeCourierTaskRequest,
  overrideGpsCourierTask: courierActions.overrideGpsCourierTaskRequest,
  // custody & manual jobs
  getCourierCustodyItems: courierActions.getCourierCustodyItemsRequest,
  createCourierCustodyItem: courierActions.createCourierCustodyItemRequest,
  reconcileCourierCustodyItem:
    courierActions.reconcileCourierCustodyItemRequest,
  createCourierManualJob: courierActions.createCourierManualJobRequest,
  // reports & live monitor
  getCourierReports: courierActions.getCourierReportsRequest,
  getCourierReport: courierActions.getCourierReportRequest,
  getCourierLiveMonitor: courierActions.getCourierLiveMonitorRequest,
  // optimization
  optimizeRoundStops: courierActions.optimizeRoundStopsRequest,
  autoAssignCourierTrip: courierActions.autoAssignCourierTripRequest,
  // shared
  resetCourierState: courierActions.resetCourierState,
  getCities: locationActions.getCitiesRequest
};

const mapStateToProps = state => ({
  courierLoading: selectCourierLoadingFromState(state),
  courierApiError: selectCourierApiErrorFromState(state),
  couriersLoading: selectCourierLoadingFromState(state),
  couriers: selectCouriersFromState(state),
  zones: selectCourierZonesFromState(state),
  centers: selectCourierCentersFromState(state),
  rounds: selectCourierRoundsFromState(state),
  roundStops: selectCourierRoundStopsFromState(state),
  roundSchedules: selectCourierRoundSchedulesFromState(state),
  shifts: selectCourierShiftsFromState(state),
  trips: selectCourierTripsFromState(state),
  tripTasks: selectCourierTripTasksFromState(state),
  eligibleCouriers: selectEligibleCouriersFromState(state),
  custodyItems: selectCourierCustodyItemsFromState(state),
  reportsList: selectCourierReportsListFromState(state),
  report: selectCourierReportFromState(state),
  liveMonitor: selectCourierLiveMonitorFromState(state),
  cities: selectCitiesListFromState(state)
});

export const CourierContainer = componentName =>
  connect(mapStateToProps, mapDispatchToProps)(Components[componentName]);
